import { DndContext, DragEndEvent } from '@dnd-kit/core'
import React, { FC, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import { RightSlider } from '../../../../../../../../components/sliders'
import { AppDispatch } from '../../../../../../../../store'
import { SnackbarActions } from '../../../../../../../../store/snackbar'
import { IGrantPipelineStage } from '../../../../../../../../types'
import { KanbanViewColumns } from './KanbanViewColumns'
import { ProjectPF } from '../../../../sharedComponents'
import { MatchedPFActions } from '../../../../../../../../store/matchedPF'
import { MatchedPFsActions } from '../../../../../../../../store/matchedPFs'

interface KanbanViewProps {
  cb: Function
  pipelineStages: IGrantPipelineStage[]
  pipelineData: Record<string, { pfs: any[]; totalAmount: number }>
}

export const KanbanView: FC<KanbanViewProps> = ({ cb, pipelineData, pipelineStages }) => {
  const { projectId = '' } = useParams()
  const dispatch = useDispatch<AppDispatch>()

  const [selectedPF, setSelectedPF] = useState('')
  const [showPFDetail, setShowPFDetail] = useState(false)

  const handleDragEnd = async (event: DragEndEvent) => {
    try {
      const { active, over, delta } = event

      if (!active || !over) return

      //handle slider click
      const { x, y } = delta
      const { matchedPFId = '' } = active.data.current as any

      if (x === 0 && y === 0 && matchedPFId) {
        handlePFSlider(matchedPFId)
        return
      }

      //handle drag & drop
      const { id: refId } = active
      const { id: newProgressStatus } = over

      if (!refId) return

      dispatch(
        MatchedPFsActions.setProgressStatus({
          matchedPFId: refId,
          progressStatus: newProgressStatus,
        }),
      )

      await dispatch(
        MatchedPFActions.updateMatchedPFAsync(
          {
            techId: projectId, refId: refId as string,
            body: { progressStatus: newProgressStatus }
          }
        )
      )

    } catch (error: any) {
      cb()
      const message = error.message || 'error while updating pf progress'
      dispatch(SnackbarActions.showSnackbar({ message }))
    }
  }
  const handlePFSlider = (matchedPFId: string) => {
    setSelectedPF(matchedPFId)
    setShowPFDetail(true)
  }

  return (
    <DndContext onDragEnd={handleDragEnd}>
      <RightSlider
        open={showPFDetail}
        setOpen={setShowPFDetail}
        outerBoxSx={{ maxWidth: '600px' }}
        closeButtonAction={() => setShowPFDetail(false)}
      >
        <ProjectPF projectId={projectId} refId={selectedPF} />
      </RightSlider>

      <KanbanViewColumns
        pipelineData={pipelineData}
        pipelineStages={pipelineStages}
      />
    </DndContext>
  )
}
